import * as React from "react";
import type { SVGProps } from "react";
const SvgPm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M9.725 4c-.088 0-.147 0-.206.03A8.32 8.32 0 0 0 4 11.794C4 16.308 7.7 20 12.22 20a8.225 8.225 0 0 0 7.75-5.51c.03-.058.03-.116.03-.204a.59.59 0 0 0-.587-.586c-.059 0-.147 0-.206.029-.734.264-1.526.38-2.319.41a7.023 7.023 0 0 1-7.046-7.033c0-.791.147-1.553.411-2.315.03-.058.03-.117.03-.205.029-.322-.235-.557-.558-.586"
    />
  </svg>
);
export default SvgPm;
